import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { OutLinedButton } from '@/Components/Buttons/OutLinedButton';

export const FormHeader = ({ 
  title, 
  titleColor = "var(--createheading-0)",
  divider = true 
}) => {
  return (
    <>
      <Box sx={{  width: '100%',
  overflow: 'visible', // Force visible overflow
  position: 'relative'}}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              color: titleColor,
              
            }}
          >
            {title}
          </Typography>
        </Box>
        {/* {divider && <Divider sx={{ 
        borderColor: 'divider', // or use your custom var
        borderBottomWidth: 1,
        my: 0.5 // Add margin if needed
      }} />} */}
      </Box>
      
    </>
  );
};
